export default __webpack_public_path__ + "static/media/professional-managed-funds.1424aa14.png";